import { render } from "./NavButton.vue?vue&type=template&id=73fcf556"
import script from "./NavButton.vue?vue&type=script&lang=ts"
export * from "./NavButton.vue?vue&type=script&lang=ts"

import "./NavButton.vue?vue&type=style&index=0&id=73fcf556&lang=scss"
script.render = render

export default script